window.onload = function() {
  const pp = document.querySelector('.pp')

  if (pp) {
    const body = pp.querySelector('.body')
    const prpts =  body.querySelectorAll('.property')

    const cntrls = pp.querySelector('.controls')
    const btns = cntrls.querySelectorAll('.control')

    const setLink = set( document.querySelector('#portfolio-link') );
    setLink(prpts[0].dataset.type)

    btns.forEach((btn, index) => {
      btn.addEventListener('click', () => handler(btn, btns, prpts, index, setLink))
    })
  }
}

function set(link) {
  return function(type) {
    link.href = `/${type}s`;
  }
}

function handler(btn, btns, prpts, i, setLink) {
  if ( btn.dataset.selected !== 'true' ) {
    prpts.forEach(unselect)
    select(prpts[i])

    btns.forEach(unselect)
    select(btn)

    setLink(prpts[i].dataset.type)
  }
}

function unselect(el) {
  el.dataset.selected = 'false'
}

function select(el) {
  el.dataset.selected = 'true'
}